import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames'
import { isIE } from '../../tools/utils';
import * as Actions from '../../store/actions';
import * as HeaderActions from '../../store/actions/header-actions';
import * as PlayActions from '../../store/actions/play-actions'

import BackArrow from '../../components/svg-icons/BackArrowIcon'

import Pagination from "../../components/pagination/Pagination";
import GallerySlide from '../../components/GallerySlide'
import {
  getSlideThumbnails,
  getGalleryVisibility,
  getActiveFrame,
  getAvailableNumberOfFrames,
  getIsAudioBook
} from '../../store/selectors/selectors'
import './style.scss';

const DEFAULT_PER_PAGE = 15;
const DEFAULT_PER_PAGE_LANDSCAPE = 10;

class NavigationGallery extends Component {
  constructor() {
    super();
    this.state = {
      activePage: 1,
      perPage: this.getOrientation() === 'landscape' ? DEFAULT_PER_PAGE_LANDSCAPE : DEFAULT_PER_PAGE,
      orientation: this.getOrientation(),
      maxVisiblePages: this.getOrientation() === 'landscape' ? 10 : 4,
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.closeGallery = this.closeGallery.bind(this);
    this.orientationChangeHandler = this.orientationChangeHandler.bind(this);
  }

  // static getDerivedStateFromProps(props, state) {
  //   const activeFrame = props.activeFrame > 0 ? props.activeFrame : 1;
  //   const activePage = Math.ceil(activeFrame / (state.perPage - 1))
  //   return {
  //     ...state,
  //     activePage
  //   }
  // }

  componentDidMount() {
    window.addEventListener('orientationchange', this.orientationChangeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.orientationChangeHandler);
  }


  orientationChangeHandler() {
    this.setState({
      orientation: this.getOrientation(),
      perPage: this.getOrientation() === 'landscape' ? DEFAULT_PER_PAGE_LANDSCAPE : DEFAULT_PER_PAGE,
      maxVisiblePages: this.getOrientation() === 'landscape' ? 10 : 4
    })
  }

  getOrientation() {
    switch (window.orientation) {
      case -90:
        return 'landscape';
      case 90:
        return 'landscape';
      case 0:
        return 'portrait';
      default:
        return 'portrait';
    }
  }
  /*
    getPerPage() {
      const ratio = this.getSize().width / this.getSize().height;

      let res = DEFAULT_PER_PAGE;
      if (ratio < 1) {
        res = 20;
      } else if (ratio >= 1.77 && ratio <= 2) {
        res = 18;
      } else if (ratio > 2) {
        res = 14;
      } else if (ratio >= 1.33 && ratio <= 1.6) {
        res = 15;
      }
      return res;
    } */

  getSize() {
    return document.getElementById('root').getBoundingClientRect();
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber });
  }

  handleSetFrameToView = (frame) => {
    this.props.setFrameToView(+frame + 1);
    this.props.toggleGalleryVisibility();
  }

  closeGallery() {
    this.props.toggleGalleryVisibility();
  }

  render() {
    const {
      images,
      activeFrame,
      galleryVisibility,
      totalImagesCount,
      isAudioBook
    } = this.props;

    if (!galleryVisibility || isAudioBook) {
      return null;
    }
    let getFrom = (this.state.activePage - 1) * this.state.perPage;
    let getTo = (this.state.activePage) * this.state.perPage;
    let imagesToShow = Object.keys(images).map((key) => images[key]);
    imagesToShow = imagesToShow.slice(getFrom, getTo);


    return (
      <div className={cx('gallery-container', { 'hidden': !galleryVisibility })}>
        <div className="gallery__header">
          <button
            className="gallery__back-button"
            onClick={this.closeGallery}
            type="button"
          >
            <BackArrow />
          </button>

          <div className="gallery-header__text">
            Navigation Gallery
          </div>

        </div>

        <div className={cx('gallery', { 'ie': isIE })}>
          {[...Array(imagesToShow.length)].map((e, i, arr) => (
            <GallerySlide
              isActiveSlide={(+imagesToShow[i].frame_n + 1) === +activeFrame}
              slideNumber={imagesToShow[i].frame_n}
              slideUrl={imagesToShow[i].download_link}
              key={imagesToShow[i].frame_n}
              setActiveFrame={this.handleSetFrameToView}
            />
          ))}

          {imagesToShow.length < 15 && <div className="gallery-spacer" />}
          {/* {imagesToShow.length < 10 && <div className="gallery-spacer gallery-spacer--lg"/>} */}

        </div>

        <Pagination
          activePage={this.state.activePage}
          itemsCountPerPage={this.state.perPage}
          totalItemsCount={totalImagesCount}
          onChange={this.handlePageChange}
          maxVisible={4}
        />
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  images: getSlideThumbnails(state),
  activeFrame: getActiveFrame(state),
  galleryVisibility: getGalleryVisibility(state),
  totalImagesCount: getAvailableNumberOfFrames(state),
  isAudioBook: getIsAudioBook(state),
});

export default connect(mapStateToProps, { ...Actions, ...HeaderActions, ...PlayActions })(NavigationGallery);


// WEBPACK FOOTER //
// ./src/containers/navigation-gallery/NavigationGallery.jsx